document.addEventListener("DOMContentLoaded", function () {
    function insertDisclaimers() {
        let reviews = document.querySelectorAll(".stamped-review"); // Target each review
        let isPolish = document.documentElement.lang === "pl"; // Detect locale

        reviews.forEach(function (review) {
            if (!review.querySelector(".review-disclaimer")) { // Prevent duplicates
                let disclaimer = document.createElement("div");
                disclaimer.classList.add("review-disclaimer");

                let disclaimerText = isPolish
                    ? "Nie jest to porada medyczna ani profesjonalna."
                    : "Disclaimer: Not medical or professional advice.";

                let tooltipText = isPolish
                    ? "Opinie o produktach odzwierciedlają wyłącznie poglądy i opinie naszych klientów, a nie Tanah Sp. z o.o. Wyrażone stwierdzenia nie stanowią porady medycznej i nie były oceniane przez organy regulacyjne."
                    : "Product reviews solely reflect the views and opinions of our customers and not those of Tanah Sp. z o.o. The statements expressed do not constitute medical advice and have not been evaluated by regulatory authorities.";

                disclaimer.innerHTML = `
                    <span class="disclaimer-text">${disclaimerText}</span>
                    <span class="tooltip-icon">ℹ️
                        <span class="tooltip-text">${tooltipText}</span>
                    </span>
                `;

                review.appendChild(disclaimer);

                // Fix tooltip click behavior on mobile
                let icon = disclaimer.querySelector(".tooltip-icon");
                let tooltip = disclaimer.querySelector(".tooltip-text");

                icon.addEventListener("click", function (event) {
                    event.stopPropagation(); // Prevents closing immediately after clicking
                    tooltip.style.display = tooltip.style.display === "block" ? "none" : "block";
                });

                document.addEventListener("click", function (event) {
                    if (!icon.contains(event.target) && tooltip.style.display === "block") {
                        tooltip.style.display = "none";
                    }
                });
            }
        });
    }

    let checkReviews = setInterval(function () {
        if (document.querySelectorAll(".stamped-review").length > 0) {
            insertDisclaimers();
            clearInterval(checkReviews);
        }
    }, 1000);
});


document.addEventListener("DOMContentLoaded", function () {
    let tooltips = document.querySelectorAll(".tooltip-icon");

    tooltips.forEach(function (tooltip) {
        let tooltipText = tooltip.querySelector(".tooltip-text");

        if (!tooltipText) return;

        tooltip.addEventListener("mouseenter", function () {
            tooltipText.style.display = "block";

            let rect = tooltipText.getBoundingClientRect();
            let screenWidth = window.innerWidth;

            if (rect.right > screenWidth) {
                tooltipText.style.left = "auto";
                tooltipText.style.right = "0px";
                tooltipText.style.transform = "translateX(0)";
            } else if (rect.left < 0) {
                tooltipText.style.left = "0px";
                tooltipText.style.right = "auto";
                tooltipText.style.transform = "translateX(0)";
            }
        });

        tooltip.addEventListener("mouseleave", function () {
            tooltipText.style.display = "none";
        });

        // Allow tap-to-toggle on mobile
        tooltip.addEventListener("click", function (event) {
            event.stopPropagation();
            tooltipText.style.display =
                tooltipText.style.display === "block" ? "none" : "block";
        });

        // Close tooltip when clicking outside on mobile
        document.addEventListener("click", function (event) {
            if (!tooltip.contains(event.target)) {
                tooltipText.style.display = "none";
            }
        });
    });
});
